
<template src="./DataSheet.html"> </template>

<script>
export default {
    name: 'DataSheet',
    props: {
        title: {
            type: String,
            required: false
        },
        value: {
            type: String,
            required: false,
        },
        subvalue: {
            type: String,
            required: false,
        },
        left: {
            title: {
                type: String,
                required: false
            },
            subtitle: {
                type: String,
                required: false
            }
        },
        right: {
            title: {
                type: String,
                required: false
            },
            subtitle: {
                type: String,
                required: false
            }
        }
    },
    data() {
        return {
            
        }
    },

}
</script>

<style lang="scss" src="./DataSheet.scss"> </style>